import { createSlice } from '@reduxjs/toolkit';
import { act } from 'react-dom/test-utils';
import { actions } from 'react-table';
const initialFilter = {
  fromDate: '',
  toDate: '',
  location: [{ id: 0, name: "All" }],
  searchText: '',
  department:[]
};
const initialState = {
  loadingFlag: 0,
  page: 1,
  data: {},
  totalPages: 0,
  pageSize: 100,
  shiftsType: 1,
  sortColumn: null,
  sortOrder: 'Acs',
  errorMessage: undefined,
  filterFields: initialFilter,
  masterDatas: {
    locationList: [],
  },
  gridloader: true,
  matchingCandidateinfo: {
    jobShiftUniqueId: '',
    locationUniqueId: '',
    acceptableTravelDistance: '',
    jobsClaimId: 0,
    navigateMatchingCandidate: false,
    editJobUniqueId: '',
  },
  multiShiftclaimDetailFlag: false,
  multiShiftUnClaimFlag: false,
  multiShiftclaimedDetail: [],
  unClaimEmployerReasons: [],
  deleteEmployerReasons: [],
  jobInfoForDailyOccurance: [],
  calendarSearch: {
    candidates: [],
    fromDate: '',
    toDate: '',
  },
  grouping: {
    group: [],
    resources: [],
  },
  updatedShiftTime: false,
  multiShiftFilterData: []
};

const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};
export const shiftsCoverageSlice = createSlice({
  name: 'shiftsCoverageListing',
  initialState,
  reducers: {
    updateShiftsCoverageListings: (state, action) => {
      state.data = action.payload.data;
      state.page = Number(action.payload.page);
    },
    updateOpenShiftsCoverageListings: (state, action) => {
      state.data = action.payload.data;
      state.page = Number(action.payload.page);
    },
    updatePaymentShiftsCoverageListings: (state, action) => {
      state.data = action.payload.data;
      state.page = Number(action.payload.page);
    },
    updateShiftsCorrectionsListings: (state, action) => {
      state.data = action.payload.data;
      state.page = Number(action.payload.page);
    },
    updateMultiShiftJobInfo: (state, action) => {
      state.data = action.payload.data;
      state.page = Number(action.payload.page);
    },
    updateCompletedShiftsCoverageListings: (state, action) => {
      state.data = action.payload.data;
      state.page = Number(action.payload.page);
    },
    updateAwaitingShiftsCoverageListings: (state, action) => {
      state.data = action.payload.data;
      state.page = Number(action.payload.page);
    },
    shiftsCoverageFailed: (state, action) => {
      state.errorMessage = action.payload;
    },
    updatePageSize: (state, action) => {
      state.pageSize = Number(action.payload.pageSize);
      state.page = 1;
    },
    updateShiftsType: (state, action) => {
      state.shiftsType = action.payload.shiftsType;
    },
    setPage: (state, action) => {
      state.page = Number(action.payload.page);
    },
    setSorting: (state, action) => {
      const currentSortColumns = state.sortColumn;
      state.sortOrder = action.payload.sortOrder;
      state.sortColumn = action.payload.sortColumn;
    },
    setFilterData: (state, action) => {
      state.filterFields[action.payload.fieldName] = action.payload.value;
    },
    updateClearFilter: (state, action) => {
      state.filterFields = initialFilter;
    },
    patchFilterFieldData: (state, action) => {
      state.filterFields = action.payload;
    },
    updateMasterDatas: (state, action) => {
      if (action.payload.locationList) {
        state.masterDatas.locationList = action.payload.locationList;
      }
    },
    setSelectedOption: (state, action) => {
      state.shiftsType = action.payload;
    },
    resetShiftsCoverage: (state, action) => {
      state.shiftsType = Number(action.payload.shiftsType);
      state.page = 1;
    },
    resetPage: (state, action) => {
      state.page = action.page;
      state.pageSize = action.pageSize;
    },
    setError: (state, action) => {
      state.error = true;
      state.errorMessage = action.payload;
    },
    setGridLoader: (state, action) => {
      state.gridloader = action.payload;
    },
    reset: () => initialState,
    setMatchincandidateInfo: (state, action) => {
      state.matchingCandidateinfo = action.payload;
    },
    setMultishiftClaimedFalg: (state, action) => {
      state.multiShiftclaimDetailFlag = action.payload;
    },
    setMultishiftClaimDeail: (state, action) => {
      state.multiShiftclaimedDetail = action.payload;
    },
    setMultishiftUnClaimByEmpFalg: (state, action) => {
      state.multiShiftUnClaimFlag = action.payload;
    },
    setLoadingFlagIncrement: (state) => {
      state.loadingFlag = state.loadingFlag + 1;
    },
    setLoadingFlagDecrement: (state) => {
      if (state.loadingFlag !== 0) {
        state.loadingFlag = state.loadingFlag - 1;
      }
    },
    setUnclaimEmployerReasons: (state, action) => {
      state.unClaimEmployerReasons = action.payload;
    },
    updateDailyEncounterInfo: (state, action) => {
      state.data = action.payload?.data?.jobShiftsData?.length
        ? action.payload?.data?.jobShiftsData[0]
        : {};
      state.page = Number(action.payload.page);
    },
    setDeleteEmployerReasons: (state, action) => {
      state.deleteEmployerReasons = action.payload;
    },
    setJobInfoForDailyOccurance: (state, action) => {
      state.jobInfoForDailyOccurance = action.payload;
    },
    setCandidateSearch: (state, action) => {
      state.calendarSearch = {
        ...state.calendarSearch,
        [action.payload.key]: action.payload.value,
      };
    },
    setGrouping: (state, action) => {
      state.grouping[action.payload.key] = action.payload.value;
    },
    refreshMultishiftInfo: (state, action) => {
      state.updatedShiftTime = action.payload;
    },
    updateMultiShiftFilterData: (state, action) => {
      state.multiShiftFilterData = action.payload
    },
    cleartTableData: (state) => {
      state.data = [];
      state.page = 1
    }
  },
});

export const {
  updateShiftsCoverageListings,
  updateOpenShiftsCoverageListings,
  updateCompletedShiftsCoverageListings,
  updateAwaitingShiftsCoverageListings,
  updatePaymentShiftsCoverageListings,
  shiftsCoverageFailed,
  updatePageSize,
  setPage,
  setSorting,
  setFilterData,
  updateMasterDatas,
  updateClearFilter,
  patchFilterFieldData,
  setSelectedOption,
  updateShiftsType,
  resetShiftsCoverage,
  resetPage,
  setError,
  setGridLoader,
  reset,
  updateMultiShiftJobInfo,
  setMatchincandidateInfo,
  setMultishiftClaimedFalg,
  setMultishiftClaimDeail,
  setMultishiftUnClaimByEmpFalg,
  setLoadingFlagIncrement,
  setLoadingFlagDecrement,
  setUnclaimEmployerReasons,
  updateDailyEncounterInfo,
  setDeleteEmployerReasons,
  setJobInfoForDailyOccurance,
  setCandidateSearch,
  setGrouping,
  refreshMultishiftInfo,
  updateMultiShiftFilterData,
  cleartTableData,
  updateShiftsCorrectionsListings
} = shiftsCoverageSlice.actions;

export default shiftsCoverageSlice.reducer;
